export enum taskTimelineScheduleStatus {
  NotScheduled = "NotScheduled",
  Scheduled = "Scheduled",
  InProgress = "In Progress",
  Submitted = "Submitted",
  Rejected = "Rejected",
  Approved = "Approved",
  Cancelled = "Cancelled",
}